import { AllNullable } from '@thyme/libs/src/typing/partial'
import { Timestamps } from '@/api/global/types/timestamps'

// TYPES --------------------
// IMPROVEME(TEA-430): Fix the Person type to match backend.
export type Person = {
  entityId: string
  firstName: string
  lastName: string
  middleInitial?: string
  preferredName?: string
  suffix?: string
  gender?: Gender
  dateOfBirth?: string
  preferredLanguage?: string
} & Timestamps

// ENUMS --------------------
export enum Language {
  english = 'English',
  spanish = 'Spanish',
  // Above order is important!
  // Make sure 'English' option #1 and 'Spanish' is option #2
  amharic = 'Amharic',
  arabic = 'Arabic',
  armenian = 'Armenian',
  asl = 'ASL',
  bengali = 'Bengali',
  burmese = 'Burmese',
  cantonese = 'Cantonese',
  creole_french = 'Creole (French)',
  creole_haitian = 'Creole (Haitian)',
  dari = 'Dari',
  farsi = 'Farsi',
  french = 'French',
  german = 'German',
  greek = 'Greek',
  gujarati = 'Gujarati',
  hebrew = 'Hebrew',
  hindi = 'Hindi',
  italian = 'Italian',
  japanese = 'Japanese',
  karen = 'Karen',
  korean = 'Korean',
  mandarin = 'Mandarin',
  nepali = 'Nepali',
  pashto = 'Pashto',
  polish = 'Polish',
  portuguese = 'Portuguese',
  punjabi = 'Punjabi',
  romanian = 'Romanian',
  russian = 'Russian',
  serbian = 'Serbian',
  somali = 'Somali',
  swahili = 'Swahili',
  tagalog = 'Tagalog',
  tigrinya = 'Tigrinya',
  ukrainian = 'Ukrainian',
  urdu = 'Urdu',
  vietnamese = 'Vietnamese',
  yiddish = 'Yiddish',
  other = 'Other',
}

export enum Gender {
  Male = 'M',
  Female = 'F',
  NonBinary = 'NB',
  PreferNotToAnswer = 'NA',
  Unknown = 'U',
  Other = 'O',
}

// REQUEST TYPES --------------------

export type PersonPrimaryKey = 'entityId'

export type CreatePersonRequest = Omit<Person, keyof Timestamps>
export type UpdatePersonRequest = Partial<
  AllNullable<Omit<CreatePersonRequest, PersonPrimaryKey>>
>
